import React from 'react'
import { Check, Dash, X } from 'react-bootstrap-icons'

import { colors } from '../../../constants/salesStyles'
import { useDispatch } from '../../../modules/store/customDispatch'
import { storeDispatchTypes } from '../../../modules/store/storeDispatchTypes'

import styles from './styles.module.scss'

interface IProps {
    withPhoto: boolean | undefined
}

const TableHeadPhotoToggle = ({ withPhoto }: IProps) => {
    const dispatch = useDispatch()

    const handleToggle = () => {
        let newValue: boolean | undefined

        // Cycle: null → true → false → null
        if (withPhoto === undefined || withPhoto === null) {
            newValue = true
        } else if (withPhoto === true) {
            newValue = false
        } else {
            newValue = undefined
        }

        dispatch({
            type: storeDispatchTypes.setWithPhotoParts,
            value: {
                withPhoto: newValue,
            },
        })
    }

    const getButtonClass = () => {
        if (withPhoto === true) {
            return styles.buttonActive
        } else if (withPhoto === false) {
            return styles.buttonInactive
        } else {
            return styles.buttonNeutral
        }
    }

    const renderIcon = () => {
        if (withPhoto === true) {
            return <Check size={14} />
        } else if (withPhoto === false) {
            return <X size={14} />
        } else {
            return <Dash size={14} />
        }
    }

    return (
        <div className={styles.wrapper}>
            <span className={styles.text}>Фото</span>
            <div className={`${styles.toggleButton} ${getButtonClass()}`} onClick={handleToggle}>
                {renderIcon()}
            </div>
        </div>
    )
}

export default TableHeadPhotoToggle

